export const HOME_DATA = 'home_data'
export const LOGIN_STATUS = 'login_status'